import { DateLimits } from "@/_old/features/filters/context/filters/filters.types";
import {
  getCurrentQuarterDates,
  getLastQuarterDates,
} from "@/_old/utils/get-quarter";
import {
  addDays,
  subDays,
  subMonths,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
  startOfWeek,
  endOfWeek,
} from "date-fns";

const today = new Date();

export const MONTH_OPTIONS = {
  TODAY: {
    label: "filter-date-today",
    value: "today",
    tracker: "USE_FILTER_TODAY",
    range: () =>
      ({
        startDate: today,
        endDate: today,
      }) as DateLimits,
  },
  YESTERDAY: {
    label: "filter-date-yesterday",
    value: "yesterday",
    tracker: "USE_FILTER_YESTERDAY",
    range: () =>
      ({
        startDate: subDays(today, 1),
        endDate: subDays(today, 1),
      }) as DateLimits,
  },
  CURRENT_WEEK: {
    label: "filter-date-current-week",
    value: "current-week",
    tracker: "USE_FILTER_WEEK",
    range: () =>
      ({
        startDate: startOfWeek(today),
        endDate: endOfWeek(today),
      }) as DateLimits,
  },
  CURRENT_MONTH: {
    label: "filter-date-current-month",
    value: "current-month",
    tracker: "USE_FILTER_CURRENT_MONTH",
    range: () =>
      ({
        startDate: startOfMonth(today),
        endDate: endOfMonth(today),
      }) as DateLimits,
  },
  LAST_MONTH: {
    label: "filter-date-last-month",
    value: "last-month",
    tracker: "USE_FILTER_LAST_MONTH",
    range: () => {
      const lastMonth = subMonths(today, 1);
      return {
        startDate: startOfMonth(lastMonth),
        endDate: endOfMonth(lastMonth),
      } as DateLimits;
    },
  },
  CURRENT_QUARTER: {
    label: "filter-date-current-quarter",
    value: "current-quarter",
    tracker: "USE_FILTER_Q",
    range: () => getCurrentQuarterDates() as DateLimits,
  },
  LAST_QUARTER: {
    label: "filter-date-last-quarter",
    value: "last-quarter",
    tracker: "USE_FILTER_LAST_Q",
    range: () => getLastQuarterDates() as DateLimits,
  },
  CURRENT_YEAR: {
    label: "filter-date-current-year",
    value: "current-year",
    tracker: "USE_FILTER_YEAR",
    range: () =>
      ({
        startDate: startOfYear(today),
        endDate: endOfYear(today),
      }) as DateLimits,
  },
};
